import { render, staticRenderFns } from "./CardSlide.vue?vue&type=template&id=bea2eeea&scoped=true&"
import script from "./CardSlide.vue?vue&type=script&lang=js&"
export * from "./CardSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea2eeea",
  null
  
)

export default component.exports